import React from "react";
import InformationTab from "./InfoSubComponents/InformationTab";
import { IoMdClose } from "react-icons/io";
import { withTranslation } from 'react-i18next';


const InfoPopup = (props) => {
  const { onClose } = props;
  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="informasi_popup">
        <button className="informasi_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose"/>
        </button>
        <div className="result_txt">{props.t('information')}</div>
        <InformationTab />
      </div>
    </div>
  );
};

export default withTranslation()(InfoPopup);
